import * as types from "../actionTypes";

export const openNotifier = (variant, message, dispatch) => {
  dispatch({ type: types.SHOW_SNACK_BAR_NOTIFIER, payload: { message: message, variant: variant } });
};

export const closeNotifier = (variant, message, dispatch) => {
  dispatch({ type: types.HIDE_SNACK_BAR_NOTIFIER, payload: { message: message, variant: variant } });
};
